import { useEffect, useRef, useState } from 'react';
import api from '../services/api';

interface HeartbeatState {
  isConnected: boolean;
  lastHeartbeat: Date | null;
  retryCount: number;
}

export const useHeartbeat = (interval: number = 120000) => { // 改为2分钟
  const [state, setState] = useState<HeartbeatState>({
    isConnected: true,
    lastHeartbeat: null,
    retryCount: 0
  });
  
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const maxRetries = 2; // 减少重试次数

  const checkHeartbeat = async () => {
    try {
      // 使用一个简单的健康检查端点
      await api.get('/health');
      
      setState(prev => ({
        isConnected: true,
        lastHeartbeat: new Date(),
        retryCount: 0
      }));
    } catch (error) {
      console.warn('心跳检测失败:', error);
      
      setState(prev => {
        const newRetryCount = prev.retryCount + 1;
        const isConnected = newRetryCount < maxRetries;
        
        if (!isConnected) {
          console.error('心跳检测失败次数过多，标记为断开连接');
        }
        
        return {
          isConnected,
          lastHeartbeat: prev.lastHeartbeat,
          retryCount: newRetryCount
        };
      });
    }
  };

  useEffect(() => {
    // 立即执行一次检查
    checkHeartbeat();
    
    // 设置定时器
    intervalRef.current = setInterval(checkHeartbeat, interval);
    
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [interval]);

  return {
    isConnected: state.isConnected,
    lastHeartbeat: state.lastHeartbeat,
    retryCount: state.retryCount,
    checkHeartbeat
  };
};







